// @ts-expect-error file not converted to TS yet
import Cookies from 'js-cookie';
import LocalStorage from 'LoginUI/lib/LocalStorage';
export const getStagedLoginRequirement = () => {
  const isSeleniumTest = Cookies.get('hs_selenium');
  if (isSeleniumTest) {
    return {};
  }
  return LocalStorage.getStagedLoginRequirement() || {};
};